import { Component, EventEmitter, Input, OnInit, Output, NgModule, AfterViewInit } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'page-component',
  templateUrl: '../sharedTemplates/page.component.html',
})
export class PageComponent {
  pageId = 0;
  pageName = '';
  pageDetailList;

  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private route: ActivatedRoute,
    public _DataHelper: DataHelper
  ) {
    this.route.params.subscribe(params => {
      //this.pageId = params['pageId'];
      this.pageName = params['pageName'];
      this.getPages(this.pageName);
      this._UiHelper.setLoadingDialog(false);
      this._UiHelper.setNavbarTitle(this.pageName, true);
      // this.ScrollToTop()
    });
  }

  getPages(e) {
    this._ApiService.getPagesbyName(e).then(result => {
      this.pageDetailList = result;
      const elementList = document.querySelectorAll('.main-page');
      const elementListSecond = document.querySelectorAll('#main-page-second-scroll');
      const element = elementList[0] as HTMLElement;
      const elementSecond = elementListSecond[0] as HTMLElement;
      if (elementSecond) {
        elementSecond.scrollTop = 0;
      }
      if (element) {
        element.scrollTop = 0;
      }
    });
  }
}
